import React from 'react';
import AutomationIcon from '@atlassian/jira-automation-menu/src/common/assets/automation.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import { IconWrapper } from './ui/AutomationMenu.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const AutomationMenu = lazy(
	() =>
		import(
			/* webpackChunkName: "async-releases-automation-menu" */ './ContextAwareAutomationMenu.tsx'
		),
);

const fallback = (
	// eslint-disable-next-line jira/integration/test-id-by-folder-structure
	<IconWrapper data-testid="jira-releases-automation-menu.ui.automation-button.disabled">
		<AutomationIcon label="" />
	</IconWrapper>
);

const AsyncReleaseAutomationMenu = (): React.JSX.Element => (
	<Placeholder name="releases-automation-menu" fallback={fallback}>
		<AutomationMenu />
	</Placeholder>
);

export default AsyncReleaseAutomationMenu;
